import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { AddCryoboxToStagingFormValues } from './types';
import { AddCryoboxToStagingResult } from '../../core/api/lab.types';

export const addCryoboxToStagingHasErrorSelector = (state: RootState): any =>
  state.addCryoboxToStaging.errors && state.addCryoboxToStaging.errors
    ? { hasError: true, message: state.addCryoboxToStaging.errors[0].message }
    : { hasError: false };

export const addCryoboxToStagingIsBusySelector = (state: RootState): boolean =>
  state.addCryoboxToStaging.status === StoreStatus.BUSY;

export const addCryoboxToStagingValuesSelector = (state: RootState): AddCryoboxToStagingFormValues | null =>
  state.addCryoboxToStaging.values || null;

export const addCryoboxToStagingResponseSelector = (state: RootState): AddCryoboxToStagingResult | null =>
  state.addCryoboxToStaging.response || null;
